class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.cachedCollectionResults = {};
    this.cachedPageResults = {};
    //this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.predictiveSearchResults = this.querySelector('.modal-result__main__product__list');
    this.predictiveSearchCollectionResults = this.querySelector('.modal-result__main__collection__list');
    this.predictiveSearchPageResults = this.querySelector('.modal-result__main__page__list');
    this.predictiveSearchTabs = document.querySelectorAll('.modal-result__main__tab');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
    this.predictiveSearchTabs.forEach(function (tab) {
      tab.addEventListener('click', function(){
        let productlists = document.querySelectorAll('.modal-result__main__product__list');
        let collectionlists = document.querySelectorAll('.modal-result__main__collection__list');
        let pagelists = document.querySelectorAll('.modal-result__main__page__list');

        let producttabs = document.querySelectorAll('.modal-result__main__product');
        let collectiontabs = document.querySelectorAll('.modal-result__main__collection');
        let pagetabs = document.querySelectorAll('.modal-result__main__page');

        if(tab.classList.contains("modal-result__main__product")) {          
          productlists.forEach(list => {
            list.classList.add("on") 
          });
          collectionlists.forEach(list => {
            list.classList.remove("on") 
          });
          pagelists.forEach(list => {
            list.classList.remove("on") 
          });

          producttabs.forEach(tab => {
            tab.classList.add("on") 
          });
          collectiontabs.forEach(tab => {
            tab.classList.remove("on") 
          });
          pagetabs.forEach(tab => {
            tab.classList.remove("on") 
          });
        }else if(tab.classList.contains("modal-result__main__collection")){
          collectionlists.forEach(list => {
            list.classList.add("on") 
          });
          productlists.forEach(list => {
            list.classList.remove("on") 
          });
          pagelists.forEach(list => {
            list.classList.remove("on") 
          });

          collectiontabs.forEach(tab => {
            tab.classList.add("on") 
          });
          producttabs.forEach(tab => {
            tab.classList.remove("on") 
          });
          pagetabs.forEach(tab => {
            tab.classList.remove("on") 
          });
        }else {
          pagelists.forEach(list => {
            list.classList.add("on") 
          });
          collectionlists.forEach(list => {
            list.classList.remove("on") 
          });
          productlists.forEach(list => {
            list.classList.remove("on") 
          });

          pagetabs.forEach(tab => {
            tab.classList.add("on") 
          });
          collectiontabs.forEach(tab => {
            tab.classList.remove("on") 
          });
          producttabs.forEach(tab => {
            tab.classList.remove("on") 
          });
        }
      });
    });
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));

  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      console.log("cached result");
      this.renderSearchResults(this.cachedResults[queryKey],this.cachedCollectionResults[queryKey]);
      this.renderSearchPageResults(this.cachedpageResults[queryKey]);
      return;
    }
    fetch(`${routes.search_url}?view=json&type=product&q=${encodeURIComponent(searchTerm)}`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        let json = JSON.parse(text);
        
        let collections = new Array;
        let resultsMarkup = json.html;
        json.results.forEach(item => {
          item.collections.forEach(collection => {
            collections[collection.id] = collection;
          });
        });
        let collectionsMarkup = "";
        
        
        for ( let id in collections){
          if(collections[id].image){
            collectionsMarkup += '<li class="grid__item scroll-trigger animate--slide-in" data-cascade=""><div class="card-wrapper product-card-wrapper underline-links-hover"><div class=" card card--standard card--media" style="--ratio-percent: 129.87012987012986%;"><div class="card__inner color-scheme-1 gradient ratio" style="--ratio-percent: 129.87012987012986%;"><div class="card__media"><div class="media media--transparent media--hover-effect">';
          }else {
            collectionsMarkup += '<li class="grid__item scroll-trigger animate--slide-in" data-cascade=""><div class="card-wrapper product-card-wrapper underline-links-hover"><div class=" card card--standard card--media" style="--ratio-percent: 129.87012987012986%;"><div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 129.87012987012986%;"><div class="card__media"><div class="media media--transparent media--hover-effect">';
          } 
          collectionsMarkup += ''
            if(collections[id].image){
              collectionsMarkup += '<img src="'+collections[id].image.src+'" sizes="(min-width: 1540px) 352px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="" class="motion-reduce">'
            }else {
              collectionsMarkup += '<img src="https://cdn.shopify.com/s/files/1/0736/7816/0130/files/camille-fournet-logo.png?v=1744784226" sizes="(min-width: 1540px) 352px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="" class="motion-reduce logo">'
            }
            
          collectionsMarkup += '</div></div></div><div class="card__content"><div class="card__information"><h3 class="card__heading h5" id="title--8981433450754">'
            collectionsMarkup += '<a href="/collections/'+collections[id].handle+'" class="full-unstyled-link" aria-labelledby="CardLink--8981433450754 Badge--8981433450754">'+collections[id].title+'</a>'
          collectionsMarkup += '</h3></div></div></div></div></li>';
        }

        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
          predictiveSearchInstance.cachedCollectionResults[queryKey] = collectionsMarkup;
        });
        this.renderSearchResults(resultsMarkup,collectionsMarkup);
        
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });

    fetch(`${routes.search_url}?view=json&type=page,article&q=${encodeURIComponent(searchTerm)}`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        let json = JSON.parse(text);
        let resultsMarkup = json.html;
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedPageResults[queryKey] = resultsMarkup;
        });
        this.renderSearchPageResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup,collectionsMarkup) {
    let lists = document.querySelectorAll('.modal-result__main__product__list');
    lists.forEach(list => {
      list.innerHTML = resultsMarkup;  
    });
    let lists1 = document.querySelectorAll('.modal-result__main__collection__list');
    lists1.forEach(list => {
      list.innerHTML = collectionsMarkup;  
    });
    this.setAttribute('results', true);
    this.removeAttribute('loading');
    this.open();
  }

  renderSearchPageResults(resultsMarkup) {
    let lists = document.querySelectorAll('.modal-result__main__page__list');
    lists.forEach(list => {
      list.innerHTML = resultsMarkup;  
    });
    this.setAttribute('results', true);
    this.removeAttribute('loading');
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    //this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);
